<template>
    <!-- DEUS SEJA LOUVADO -->
    <div id="corpo-landing-page">
        <HeaderLandingPage/>
        <BannerLandingPage/>

        <CardsCTALandingPage/>

        <SobreEmpresaLandingPage/>

        <ServicosLandingPage
        @abrir-servico="setarAbrirServico"
        />

        <GaleriaLandingPage
        @abrir-imagem="setarAbrirImagem"
        />

        <CTAFinalLandingPage/>

        <FooterLandingPage/>

        <a :href="linkBotaoWhatApp" target="_blank" id="melhora-cta" data-aos="fade-left" data-aos-duration="1200">
            <p id="texto-wp">Entre em contato agora!</p>
            <img src="@/assets/whatsapp-icon.svg" alt="wp" id="botao-wp">
        </a>


        <section class="pop-up" @click.stop="abrirServico=false" v-if="abrirServico">
            <ServicoAbertoLandingPage
            :servicoAberto="servicoAberto"
            @fechar="abrirServico=false"
            />
        </section>
        
        <section class="pop-up" @click.stop="abrirImagem=false" v-if="abrirImagem">
            <ImagemAbertaLandingPage
            :imagemAberta="imagemAberta"
            @fechar="abrirImagem=false"
            />
        </section>

    </div>
</template>

<script>
import BannerLandingPage from './components/BannerLandingPage.vue';
import CardsCTALandingPage from './components/CardsCTALandingPage.vue';
import CTAFinalLandingPage from './components/CTAFinalLandingPage.vue';
import FooterLandingPage from './components/FooterLandingPage.vue';
import GaleriaLandingPage from './components/GaleriaLandingPage.vue';
import HeaderLandingPage from './components/HeaderLandingPage.vue'
import ImagemAbertaLandingPage from './components/ImagemAbertaLandingPage.vue';
import ServicoAbertoLandingPage from './components/ServicoAbertoLandingPage.vue';
import ServicosLandingPage from './components/ServicosLandingPage.vue';
import SobreEmpresaLandingPage from './components/SobreEmpresaLandingPage.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
    name: 'App',
    components: {
        HeaderLandingPage,
        BannerLandingPage,
        CardsCTALandingPage,
        SobreEmpresaLandingPage,
        ServicosLandingPage,
        ServicoAbertoLandingPage,
        GaleriaLandingPage,
        FooterLandingPage,
        CTAFinalLandingPage,
        ImagemAbertaLandingPage
    },

    data(){
        return{
            abrirServico: false,
            servicoAberto: null,

            abrirImagem: false,
            imagemAberta: null,

            linkBotaoWhatApp: "https://wa.me/5535999013609?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
        }
    },

    watch: {
        abrirServico(valor) {
            document.body.style.overflow = valor ? 'hidden' : ''
        },

        abrirImagem(valor) {
            document.body.style.overflow = valor ? 'hidden' : ''
        }
    },

    methods:{
        setarAbrirServico(servico){
            if (this.servicoAberto){
                this.servicoAberto = null
            }
            this.servicoAberto = servico
            this.abrirServico = true
        },

        setarAbrirImagem(imagem){
            if (this.imagemAberta){
                this.imagemAberta = null
            }
            this.imagemAberta = imagem
            this.abrirImagem = true
        }
    },

    mounted() {
        AOS.init({ duration: 700, easing: 'ease-out-quart', once: true })
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
:root{
    /* GERAL */
    --cor-tema: #0f0f54;
    --cor-branco-texto: #f6f6f7;

    /* HEADER */
    --cor-fundo-header: #fcfcfc;
    --cor-texto-header: #707070;
    --cor-texto-azul-header: #10319e;
    --cor-texto-pequeno-header: #707070a0;

    /* CARDS CTA */
    --cor-icone-card-cta: #707070a0;
    --cor-texto-card-cta: #707070a0;
    --cor-texto-pequeno-card-cta: #707070a0;
}


*{
    padding: 0;
    margin: 0;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    /* overflow-x: hidden; */
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-behavior: smooth;
}

::-webkit-scrollbar {
  display: none;
}


#corpo-landing-page{
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    position: relative;
}

#melhora-cta{
    position: fixed;
    bottom: 30px;
    right: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    text-decoration: none;
}

#texto-wp{
    font-size: 12px;
    font-weight: 450;
    color: #fcfcfc;
    background-color: #25D366;
    border-radius: 100px;
    padding: 10px 12px;

}

#botao-wp{
    width: 30px;
    height: 30px;
    object-fit: cover;
    cursor: pointer;
}

.pop-up{
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-color: #1d1d1d60;
    z-index: 200;
    backdrop-filter: blur(3px);
}

.x{
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: all ease 0.4s;
    border: none;
    background: none;
    color: #707070;
}

.x:hover{
    opacity: 0.7;
}

@keyframes aparecer {
    0%{
        opacity: 0%;
    }
    100%{
        opacity: 100%;
    }
}

@media (max-width: 600px){
    #melhora-cta{
        bottom: 24px;
        right: 24px;
    }
}
</style>
